/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipment">;
    readonly " $refType": "PdpRespSidebarBlurbShipping_shipment";
};
export type PdpRespSidebarBlurbShipping_shipment$data = PdpRespSidebarBlurbShipping_shipment;
export type PdpRespSidebarBlurbShipping_shipment$key = {
    readonly " $data"?: PdpRespSidebarBlurbShipping_shipment$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_shipment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_shipment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipment"
    }
  ],
  "type": "Shipment",
  "abstractKey": null
};
(node as any).hash = '14e7448f24acf562c4ea9972f73dc8ba';
export default node;
